import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo, useState } from 'react';
import { BaseQuestionAnswerComponent } from '../../../bases';
import styled from '@xstyled/styled-components';
import { Row } from 'antd';
import { useQuestionContext } from '../../../core';
import { AnswerItem } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledMatchingAnswerWrapper = styled(Row)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-input-affix-wrapper {\n    height: 100%;\n  }\n  margin-bottom: 8px;\n"])));
export var MatchingAnswerComponent = function MatchingAnswerComponent(_ref) {
  var _matchingQuestion$sub;

  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var matchingQuestion = question;
  var matchingQuestionLabel = states.matchingQuestionLabel,
      answers = states.answers;

  var _useState = useState({}),
      selectedAnswers = _useState[0],
      setSelectedAnswers = _useState[1];

  var answerOptions = useMemo(function () {
    if (!matchingQuestion.answers || matchingQuestion.answers.length === 0) {
      return [];
    }

    return matchingQuestion.answers.map(function (answer) {
      return {
        value: answer.id.toString(),
        label: answer.description
      };
    });
  }, [matchingQuestion.answers]);
  var onChangeAnswer = actions.onChangeAnswer;

  var handleChangeAnswer = function handleChangeAnswer(subQuestionId, answerId) {
    setSelectedAnswers(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, subQuestionId, answerId));
    });
    onChangeAnswer === null || onChangeAnswer === void 0 ? void 0 : onChangeAnswer(subQuestionId, answerId);
  };

  return /*#__PURE__*/_jsx(BaseQuestionAnswerComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: (_matchingQuestion$sub = matchingQuestion.subQuestions) === null || _matchingQuestion$sub === void 0 ? void 0 : _matchingQuestion$sub.map(function (subQ, index) {
        var _answers$find, _answers$find$value;

        var selectedAnswerId = selectedAnswers[subQ.id.toString()] || (answers === null || answers === void 0 ? void 0 : (_answers$find = answers.find(function (a) {
          return a.subQuestionId === subQ.id.toString();
        })) === null || _answers$find === void 0 ? void 0 : (_answers$find$value = _answers$find.value) === null || _answers$find$value === void 0 ? void 0 : _answers$find$value.answerId);
        return /*#__PURE__*/_jsx(StyledMatchingAnswerWrapper, {
          align: "middle",
          gutter: [8, 16],
          children: /*#__PURE__*/_jsx(AnswerItem, {
            index: index + matchingQuestion.index,
            isSelected: !!selectedAnswers[subQ.id.toString()] || !!(answers !== null && answers !== void 0 && answers.find(function (a) {
              return a.subQuestionId === subQ.id.toString();
            })),
            readonly: false,
            subQuestionDescription: subQ.description,
            selectedValue: selectedAnswerId,
            onSelect: function onSelect(value) {
              return handleChangeAnswer(subQ.id.toString(), value);
            },
            options: answerOptions,
            isShowCorrectAnswer: false,
            labels: matchingQuestionLabel
          }, subQ.id.toString())
        }, subQ.id.toString());
      })
    })
  });
};